export interface AuthErrorOptions {
  authType?: string;
  attempts?: number;
  debugInfo?: unknown;
}

class AuthError extends Error {
  attempts: number;
  authType?: string;
  debugInfo?: unknown;
  constructor({
    authType,
    attempts,
    debugInfo,
  }: AuthErrorOptions) {
    super();
    this.attempts = attempts || 0;
    this.authType = authType;
    this.debugInfo = debugInfo;
  }
}

export class LoginRequiredError extends AuthError {
  constructor({
    authType,
    debugInfo,
    attempts,
  }: AuthErrorOptions = {}) {
    super({ authType, attempts, debugInfo });
    this.name = 'LoginRequiredError';
  }
}

export class HttpRequestFailedError extends AuthError {
  constructor({
    authType,
    attempts,
    debugInfo,
  }: AuthErrorOptions = {}) {
    super({ authType, attempts, debugInfo });
    this.name = 'HttpRequestFailedError';
  }
}

export class InteractionRequiredError extends AuthError {
  constructor({
    authType,
    attempts,
    debugInfo,
  }: AuthErrorOptions = {}) {
    super({ authType, attempts, debugInfo });
    this.name = 'InteractionRequiredError';
  }
}

export class UnhandledError extends AuthError {
  constructor({
    authType,
    debugInfo,
    attempts,
  }: AuthErrorOptions = {}) {
    super({ authType, attempts, debugInfo });
    this.name = 'UnhandledError';
  }
}

export class UndefinedAuthenticationError extends Error {
  authType?: string;
  constructor(authType?: string) {
    super();
    this.name = 'UndefinedAuthenticationError';
    this.authType = authType;
  }
}
